// extracted by mini-css-extract-plugin
export var truncate = "_h-0";